




import { Component, Mixins, Prop } from "vue-property-decorator";
import { IKeyHandleable } from "./IKeyHandleable";

@Component
export default class DeleteKeyHandler extends Mixins() implements IKeyHandleable {
  @Prop()
  deleted: () => boolean;

  handleKeyDowned(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if ((event.key !== "Delete") && (event.key !== "Del")) {
      return false;
    }
    if (isInputting) {
      return false;
    }
    return !!this.deleted
        && this.deleted();
  }

  handleKeyUpped(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    return false;
  }
}
